import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const markAllNotificationsAsRead = async () => {
  const url = `${ backendUrl }/api/notifications/`;
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(errorData.detail || 'Ошибка при отметке уведомлений как прочитанных');
    }

    return response;
  } catch(error){
    console.error('Ошибка при отправке POST запроса на /notifications/:', error);
    throw error;
  }
};